// Mirror of src/lib/venue-branding.ts, keep these in sync.
// Same curated list of fonts a venue admin can choose, same fallback stacks.
export const VENUE_FONT_FAMILIES = [
  { value: "system", label: "System default", stack: "system-ui, -apple-system, Segoe UI, Roboto, sans-serif" },
  { value: "Inter", label: "Inter", stack: "'Inter', system-ui, sans-serif" },
  { value: "Space Grotesk", label: "Space Grotesk", stack: "'Space Grotesk', system-ui, sans-serif" },
  // Heavy geometric display family, goes up to ExtraBold (800), good for big
  // uppercase venue-name headings. `weights` controls which Google weights load.
  { value: "Syne", label: "Syne (display)", stack: "'Syne', system-ui, sans-serif", weights: [400, 500, 600, 700, 800] },
  { value: "Playfair Display", label: "Playfair Display (serif)", stack: "'Playfair Display', Georgia, serif" },
  { value: "Fraunces", label: "Fraunces (serif)", stack: "'Fraunces', Georgia, serif" },
  { value: "JetBrains Mono", label: "JetBrains Mono (monospace)", stack: "'JetBrains Mono', ui-monospace, monospace" },
] as const;

export function fontStackFor(value: string | null | undefined): string {
  const match = VENUE_FONT_FAMILIES.find((f) => f.value === value);
  return match?.stack ?? VENUE_FONT_FAMILIES[0].stack;
}

// Google Fonts weights to request for a curated family. Defaults to the common
// 400–700 set; a family may override (e.g. Syne, which serves up to 800).
// Requesting a weight outside a font's axis makes the whole css2 request fail,
// so keep these in step with what Google actually serves.
const DEFAULT_GOOGLE_WEIGHTS = [400, 500, 600, 700] as const;
export function googleWeightsFor(value: string | null | undefined): readonly number[] {
  const match = VENUE_FONT_FAMILIES.find((f) => f.value === value);
  return match && "weights" in match ? match.weights : DEFAULT_GOOGLE_WEIGHTS;
}
